import { Spin } from 'antd'
import { useLayoutEffect, useState } from 'react'
import { useIsMutating } from 'react-query'
import { useParams } from 'react-router-dom'
import Headline from '../../components/Headline'
import { CREATE_PACKAGE_KEY } from '../../hooks/reactQuery/usePackage'
import { MovingStatus, PackType } from '../../types'
import { makeDefaultPackageInfo } from '../../utils/makeDefaultPackageInfo'
import UploadPackageInfo from '../upload/progress/UploadPackageInfoForm'

export default function CreatePackageInfo() {
  const { packType, movingStatus } = useParams<{
    packType: PackType
    movingStatus: MovingStatus
  }>()
  const [packageAndSticker, setPackageAndSticker] = useState(
    makeDefaultPackageInfo({}),
  )
  useLayoutEffect(() => {
    setPackageAndSticker(makeDefaultPackageInfo({ packType, movingStatus }))
  }, [packType, movingStatus])
  const isMutatingPackage = useIsMutating(CREATE_PACKAGE_KEY)

  return (
    <Spin spinning={isMutatingPackage > 0} delay={500} tip="Loading...">
      <Headline
        id={`Upload.PkgCreation.selectPackType.headline.${packType}`}
        defaultMessage=""
        styles={{
          margin: '22px 0px 0px 0px',
          fontFamily: 'NotoSans',
          fontSize: '34px',
          lineHeight: '36px',
          letterSpacing: 0,
        }}
      />
      <UploadPackageInfo packageAndSticker={packageAndSticker} />
    </Spin>
  )
}
